<template>
	<list hide-delete hide-edit hide-select
		headers="utility_code,station_N,building_N,address,domoupravitel_name,domoupravitel_phone,domoupravitel_email"
		:filter="filter"
		:item-class="()=>'cursor-pointer'"
		@click:row="clickRow"
	/>
</template>

<style>
tr.cursor-pointer > td {
	cursor: pointer;
}
</style>

<script>
import List from "@/ittijs/List";
import Model from "../stations/Model";
import SelectedUtilityMixin from "@/ittijs/SelectedUtilityMixin";

const imodel = new Model;

export default {
	components: {List},

	mixins: [
		SelectedUtilityMixin,
	],

	provide: function () {
		return {
			imodel,
		};
	},

	props: {
		number: String,
		building: String,
		address: String,
		id: String,
		routeName: String,
	},

	computed: {
		filter(){
			return {
				glue: "AND",
				rules: [
					{
						field: "utility_code",
						op: "eq",
						value: this.selectedUtility,
					},
					{
						field: "station_N",
						op: "bw",
						value: this.number || null,
					},
					{
						field: "building_N",
						op: "bw",
						value: this.building || null,
					},
					{
						field: "address",
						op: "cn",
						value: this.address || null,
					},
					{
						field: "id",
						op: "eq",
						value: this.id || null,
					},
				],
			}
		},
	},

	methods: {
		async clickRow(row){
			const data = await imodel.getLatestSessionInfo(row.id);
			if (data !== null) {
				this.$router.push({
					name: this.routeName,
					params: {
						utility: data.utility,
						session: data.session,
						station: data.station,
					},
				});
			}
		},
	},

}
</script>